import AdsError from './AdsError.js'

export class GetSearchStatsGenericError extends AdsError {}
